import React from 'react'

import useResponsive from '../hooks/useResponsive'

export default (props) => {

  const { isWidescreen, isTablet, isMobile } = useResponsive()

  const cloudinary = `https://res.cloudinary.com/dzxowa2ja/image/upload`
  const transpPixel = `https://res.cloudinary.com/dzxowa2ja/image/upload/v1602026559/1px-transparent_emxqwk.png`

  return (
    <div className="illus__canvasWrapper">
      <div className="illus__canvas">
        <img loading="eager" className="branch illus__key"
          src={ isTablet  ? cloudinary + '/v1597757516/key_fukkhj.png' : transpPixel }
          alt="Une belle clé illustrée"/>

        <img loading="eager" className="branch illus__code"
          src={ cloudinary + (isMobile ? '/v1602078558/code-mobile_kbee67.png' : '/v1597757516/code_f8m0vi.png')}
          alt="Une fenêtre de code illustrée"/>
        <img loading="eager" className="branch illus__coffee"
          src={ cloudinary + (isMobile ? '/v1602078558/coffee-mobile_t2lzod.png' : '/v1597757516/coffee_qjmk4a.png')}
          alt="Une tasse de café illustrée"/>

        <img loading="eager" className="branch illus__molecule"
          src={ isTablet ? cloudinary + '/v1597757516/molecule_vgjknq.png' : transpPixel}
          alt="Une molécule d'H2O illustrée"/>
        <img loading="eager" className="animal illus__jellyfish"
          src={ isTablet ? cloudinary + '/v1597247129/jellyfish_d6yggq.png' : transpPixel}
          alt="Une méduse démoniaque illustrée"/>
        <img loading="eager" className="animal illus__dragon"
          src={ isTablet ? cloudinary + '/v1597757516/dragon_frszgr.png' : transpPixel}
          alt="Un dragon médiéval illustré"/>

        <img loading="eager" className="star illus__moon"
          src={ isWidescreen ? cloudinary + '/v1597757517/moon_y64ylz.png' : transpPixel}
          alt="Une petite lune illustrée"/>

        <img loading="eager" className="star illus__star-left-1"
          src={ isTablet ? cloudinary + '/v1597247129/star-left-1_vx4k6p.png' : transpPixel}
          alt="Une petite étoile illustrée"/>
        <img loading="eager" className="star illus__star-left-2"
          src={ isTablet ? cloudinary + '/v1597247129/star-left-2_ltalbb.png' : transpPixel}
          alt="Une autre petite étoile illustrée"/>
        <img loading="eager" className="star illus__star-left-3"
          src={ isTablet ? cloudinary + '/v1597247129/star-left-3_cx8g6k.png' : transpPixel}
          alt="Encore une petite étoile illustrée"/>

        <img loading="eager" className="base illus__rock-big"
          src={ isWidescreen ? cloudinary + '/v1597247129/rock-big_cscsuo.png' : transpPixel }
          alt="Un gros rocher flottant illustré"/>
        <img loading="eager" className="base illus__rock-arrow"
          src={ isWidescreen ? cloudinary + '/v1597247129/rock-arrow_rzflxf.png' : transpPixel }
          alt="Un rocher en forme de flèche illustré"/>

        <img loading="eager" className="base illus__me"
          src={ cloudinary + (isMobile ? '/v1602078325/me-border-white_x1eqjx.png' : '/v1597767660/me_a6xjae.png')}
          alt="Léo illustré"/>
        <img loading="eager" className="base illus__strawberry"
          src={ cloudinary + '/v1597767660/strawberry_qa6nel.png'}
          alt="Une fraise ailée illustrée"
          onMouseEnter={(e) => !isMobile && props.hoverStrawberry(e.target) }/>
      </div>
    </div>
  )
}